import { Link } from 'react-router-dom'
import { Button } from '../../components/button'
import { formatDate } from '../../helpers'
import {
  useGetFeaturedEventsQuery,
  useUnfeatureEventMutation,
} from '../../redux-toolkits/events/events.slice'
import { FeaturedEvent } from '../../redux-toolkits/events/events.type'

function storefrontName(featured: FeaturedEvent) {
  const centre = featured.fulfilmentCentre
  if (!centre) return 'Deleted storefront'
  return centre.role === 'PARENT' ? `${centre.name} (parent)` : centre.name
}

/** The event featured on each storefront, with a way to remove it. */
export function FeaturedEventsPanel() {
  const { data, isFetching } = useGetFeaturedEventsQuery()
  const [unfeatureEvent, { isLoading: removing, originalArgs }] =
    useUnfeatureEventMutation()
  const featuredEvents = data?.data ?? []

  return (
    <div className="flex flex-col gap-3">
      <p className="font-medium text-base">Featured events</p>
      {!isFetching && !featuredEvents.length && (
        <p className="text-sm text-sec-black">
          No featured events yet. Use Feature on an event below.
        </p>
      )}
      {featuredEvents.map((featured) => {
        const centreId = featured.fulfilmentCentre?._id
        return (
          <div
            key={featured._id}
            className="flex items-center justify-between gap-3 border rounded-lg px-4 py-3"
          >
            <div className="flex flex-col">
              <p className="text-sm text-sec-black">
                {storefrontName(featured)}
              </p>
              {featured.event ? (
                <Link
                  to={`/events/${featured.event._id}`}
                  className="font-medium hover:underline"
                >
                  {featured.event.name}
                  {featured.event.eventTicketSettings?.eventDate &&
                    ` · ${formatDate(
                      featured.event.eventTicketSettings.eventDate,
                      'DD MMM yyyy',
                    )}`}
                </Link>
              ) : (
                <p className="font-medium">Event no longer exists</p>
              )}
            </div>
            <Button
              type="button"
              label="Remove"
              className="!w-fit"
              loading={
                removing && originalArgs?.fulfilmentCentreId === centreId
              }
              // Without a centre the backend would clear Good Online's instead.
              disabled={removing || !centreId}
              onClick={() => {
                if (centreId)
                  void unfeatureEvent({ fulfilmentCentreId: centreId })
              }}
            />
          </div>
        )
      })}
    </div>
  )
}
